"use client";
import s from "./SectionRelated.module.scss";
import { SampleCardProps } from "components/shared/SampleCard";
import { SamplesSlider } from "components/shared/SamplesSlider";
import { SampleType } from "types/shared";
import { Section } from "@/components/layout/Section";
import { Button } from "@/components/UI/buttons/Button";

type SectionRelatedProps = {
  slug: string;
  samples: SampleCardProps[];
};

export const SectionRelated = ({ samples, slug }: SectionRelatedProps) => (
  <Section
    icon="/img/icons/sections/icon-files.svg"
    heading={
      <>
        <span>Related</span> essays
      </>
    }
    subheading="We post free essay examples for college on a regular basis. Stay in the know!"
    className={s.section}
    divider
  >
    <SamplesSlider
      className={s.slider}
      items={samples.filter((sample) => sample.slug !== slug).slice(0, 6)}
    />
    <div className={s.btnWrap}>
      <Button tag="internalLink" type="secondary" href="/search" className={s.btn}>
        Show more essays
      </Button>
    </div>
  </Section>
);
